import { DatePipe, NgFor, NgIf } from '@angular/common';
import { Component, Input } from '@angular/core';
import { IListingRating, RatingType, User } from '@curbnturf/entities';
import { UserImageComponent } from '@curbnturf/image-processing/src/lib/user-image/user-image.component';
import { NgbRating } from '@curbnturf/ng-bootstrap/src/lib/rating/rating';
import { UserFacade } from '@curbnturf/user/src/lib/+state/user.facade';
import { RatingDisplayComponent } from '../rating-display/rating-display.component';

@Component({
  selector: 'curbnturf-review-display',
  templateUrl: './review-display.component.html',
  styleUrls: ['./review-display.component.scss'],
  standalone: true,
  imports: [DatePipe, NgIf, NgbRating, NgFor, RatingDisplayComponent, UserImageComponent],
})
export class ReviewDisplayComponent {
  @Input() ratings: IListingRating[] = [];

  @Input() boondock: boolean = false;

  get rating(): number {
    return this.getRatingAvg(RatingType.overall);
  }

  get ratingAccuracy(): number {
    return this.getRatingAvg(RatingType.accuracy);
  }

  get ratingCheckIn(): number {
    return this.getRatingAvg(RatingType.checkin);
  }

  get ratingCommunication(): number {
    return this.getRatingAvg(RatingType.communication);
  }

  get ratingLocation(): number {
    return this.getRatingAvg(RatingType.location);
  }

  get ratingQuality(): number {
    return this.getRatingAvg(RatingType.quality);
  }

  get ratingValue(): number {
    return this.getRatingAvg(RatingType.value);
  }

  get overallCount(): number {
    return this.overallRatings.length;
  }

  get overallRatings(): IListingRating[] {
    if (this.ratings) {
      return this.ratings.filter((rating) => rating.topic === RatingType.overall);
    }

    return [];
  }

  constructor(private userFacade: UserFacade) {}

  getName(user: User) {
    return User.getName(user);
  }

  selectUser(id: number) {
    this.userFacade.load({ id });
  }

  private getRatingAvg(topic: string): number {
    if (this.ratings) {
      let length = 0;

      return (
        Math.round(
          (this.ratings.reduce((total, rating) => {
            if (rating.topic !== topic) {
              return total;
            }
            length = length + 1;
            return total + rating.score.score;
          }, 0) /
            length) *
            10,
        ) / 10
      );
    }

    return 0;
  }
}
